module.exports = __webpack_public_path__ + "static/media/C (8).c3245e81.jpg";